module.exports = __webpack_public_path__ + "img/hzzw.ef41c6b9.jpg";